export default function() {
  if(/Safari/.test(navigator.userAgent)) {
    // browser is Safari
    window.onpageshow = function(event) {
      if(event.persisted) {
        // page is loaded from cache
        window.location.reload();
      }
    };
  } else if (/Trident.*rv:11/.test(navigator.userAgent)) {
    // browser is IE11
    if(window.performance.navigation.type == 2) {
      // page is loaded from cache
      window.location.reload();
    }
  }
}
